module.exports = __webpack_public_path__ + "img/team_r_t.02b03b7a.jpg";